import { Injectable } from '@angular/core';
import {Configuration, Usuario, Visibility} from '../interfaces/interfaces';
import { Project } from '../interfaces/interfaces';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Entity } from 'app/pages/product/product.model';
import { AttributeValue } from 'app/components/attributes/attributes.model';
import {Permission, Preference, Role} from '../components/role-form/role.model';


@Injectable({
    providedIn: 'root'
})
export class SystemService {
    visibility: Visibility;

    get roles(): Role[] {
        return this._roles;
    }

    set roles(value: Role[]) {
        this._roles = value;
        this.rolesMap = new Map<number, Role>();
        for (const role of value) {
            this.rolesMap.set(role.id, role);
        }
    }

    url =  '/ypm/api/fm';
    private _usuario: Usuario;
    clients: Entity[];
    teams: Entity[];
    private _roles: Role[];
    users: Entity[];
    allUsers: Entity[];
    mapActionPerm: Map<string, string>;
    mapCategoryPerm: Map<string, string>;
    mapConfiguration: Map<string, Configuration>;
    mapPreference: Map<string, Preference>;
    rolesMap: Map<number, Entity>;
    allPermissions: Permission[];

    allColumns = ['area', 'type', 'name', 'team', 'client', 'status', 'model', 'inCharge', 'nonBilled'];
    filteredColumns: any[];

    constructor(private _httpClient: HttpClient) {

    }

    getMyProjects(): Observable<Project[]>{
        return this._httpClient.get<Project[]>(this.url + '/project');
    }


    compareFunction(o1: any, o2: any): boolean {
        if (o1 === null && o2 === null) {
            return true;
        }
        if (o1 === null || o2 === null) {
            return false;
        }
        return (o1.id === o2.id);
    }

    compareStr(o1: any, o2: any): boolean {
        return (o1 === o2);
    }


    getTeams(): Observable<Entity[]>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<Entity[]>('/ypm/api/fm/team');
    }

    getClients(): Observable<Entity[]>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<Entity[]>('/ypm/api/fm/client');
    }

    getUsers(): Observable<Entity[]>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<Entity[]>('/ypm/api/fm/user');
    }

    getRoles(): Observable<Role[]>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<Role[]>('/ypm/api/fm/role');
    }

    exportImport(type: string, year: number, month: number): Observable<any> {
        return this._httpClient.get('/ypm/api/fm/exportImport/' + type + '/' + year + '/' + month);
    }

    importFile(formData: FormData): Observable<any> {
        return this._httpClient.post('/ypm/importExport', formData);
    }

    getAttributesFromType(typeId: number): Observable<AttributeValue[]>{
        return this._httpClient.get<AttributeValue[]>('/ypm/api/fm/attributes/' + typeId);
    }


    logout(): void {
        this._httpClient.post(this.url + '/logout', {}).subscribe(
            () => {
                this._usuario = null;
                this.mapActionPerm = new Map<string, string>();
                this.mapCategoryPerm = new Map<string, string>();
                this.mapPreference = new Map<string, Preference>();
                this.mapConfiguration = new Map<string, Configuration>();
                this.rolesMap = new Map<number, Entity>();
                this.allPermissions = [];
            },
            error => {
                console.error('Logout failed', error);
            }
        );
    }


    get usuario(): Usuario {
        return this._usuario;
    }

    set usuario(value: Usuario) {
        const permissions: Permission[] = value.permissions;
        this.mapActionPerm = new Map<string, string>();
        this.mapCategoryPerm = new Map<string, string>();
        for (const permission of permissions) {
            if (!this.mapActionPerm.has(permission.action)) {
                this.mapActionPerm.set(permission.action, permission.action);
            }
            if (!this.mapCategoryPerm.has(permission.category)) {
                this.mapCategoryPerm.set(permission.category, permission.category);
            }
        }
        this._usuario = value;

        this.mapPreference = new Map<string, Preference>();
        if (value.preferences) {
            const preferences: Preference[] = value.preferences;
            for (const preference of preferences) {
                this.mapPreference.set(preference.name, preference);
            }
        }
        this.countPref();
    }

    canAction(action: string): boolean{
        return this.mapActionPerm.has(action);
    }

    canCategory(category: string): boolean{
        return this.mapCategoryPerm.has(category);
    }

    getPreference(key: string): Preference{
        return this.mapPreference.get(key);
    }


    guardarFiltros(filterPref: any): Observable<any> {
        for (const key of this.allColumns) {
            this.upadatePref('filter_' + key, filterPref[key]);
        }
        return this._httpClient.post(this.url + '/preferences', this.usuario);
    }

    updatePrefOnServer(): Observable<any> {
        return this._httpClient.post(this.url + '/preferences', this.usuario);
    }

    upadatePref(key: string, value: string): void {
        let pref: Preference;
        if (!this.mapPreference.has(key)){
            pref = new Preference();
            pref.id = 0;
            this.usuario.preferences = this.usuario.preferences ? this.usuario.preferences : [];
            this.usuario.preferences.push(pref);
            this.mapPreference.set(key, pref);
        }else {
            pref = this.mapPreference.get(key);
        }
        pref.name = key;
        pref.value = value;
    }

    countPref(): number {
        this.filteredColumns = [];

        for (const filterColumn of this.allColumns) {
            const value: string = this.getPrefValue('filter_' + filterColumn);
            if (value && value !== '' && value !== 'false'){
                this.filteredColumns.push({key: filterColumn, value: value});
            }
        }
        return this.filteredColumns.length;

    }

    getPrefValue(key: string): string{
        const pref: Preference = this.getPreference(key);
        return !pref || pref.value === '' ? '' : pref.value;
    }


    getRole(roleId: number): Entity {
        return this.rolesMap.get(roleId);
    }

    loadUserConfiguration(usuario: Usuario): void {
        const configuration: Configuration[] = usuario.configurations;
        this.mapConfiguration = new Map<string, Configuration>();
        for (const config of configuration) {
            this.mapConfiguration.set(config.key, config);
        }
        if (this.mapConfiguration.has('visibility')) {
            this.visibility = new Visibility(this.getJson('visibility'));
        }else {
            this.visibility = new Visibility();
        }

    }

    getBoolean(key: string): boolean {
        return this.mapConfiguration.has(key) && this.mapConfiguration.get(key).value === 'true';
    }

    getStringArray(key: string): string[] {
        return this.mapConfiguration.has(key) && this.mapConfiguration.get(key).value ? this.mapConfiguration.get(key).value.split(',') : [];
    }

    getJson(key: string): any {
        return this.mapConfiguration.has(key) && this.mapConfiguration.get(key).value ? JSON.parse(this.mapConfiguration.get(key).value) : null;
    }

    getConfiguration(key: string): Configuration {
        return this.mapConfiguration.get(key);
    }

    getConfigurationValue(key: string): string {
        return this.mapConfiguration.has(key) ? this.mapConfiguration.get(key).value : null;
    }

}
